import Hero from './Hero';
import MovieCard from './MovieCard';
import { useEffect, useState } from 'react';

const Home = () => {
	const [movies, setMovies] = useState([]);
	const [posterUrl, setPosterUrl] = useState('');

	// add a useEffect so the home page results only happen once when the page initially loads
	useEffect(() => {
		fetch(
			`https://api.themoviedb.org/3/movie/now_playing?api_key=23f28c668f59a7895010a1481a3df51d&language=en-US&page=1`,
		)
			.then(response => response.json())
			.then(data => {
				//set searchResults state
				setMovies(data.results);
				setPosterUrl(`https://image.tmdb.org/t/p/w500/${movies.poster_path}`);
			});
	}, []);

	const results = movies.map((obj, i) => {
		if (obj) {
			if (obj.poster_path) {
				return <MovieCard movie={obj} key={i} />;
			}
		}
	});

	return (
		<div>
			<Hero text='New Movies' />
			<div className='container'>
				<div className='row'>
					{/* <HomeCard movie={movies[0]} /> */}
					{results}
				</div>
			</div>
		</div>
	);
};

export default Home;
